import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './engagementsGeneral.intl.json';

export const useEngagementsGeneralIntl = () => useIntlModule(messages);
